import { render } from "./index.vue?vue&type=template&id=09001503&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=09001503&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09001503"],['__file',"src/components/PaginaErro/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09001503"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09001503', __exports__)) {
    console.log('reload')
    api.reload('09001503', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=09001503&scoped=true", () => {
    console.log('re-render')
    api.rerender('09001503', render)
  })

}


export default __exports__